import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export type State = 'all' | 'current' | 'senior'

const collegeStudentsPreference = createSlice({
  name: 'collegeStudentsPreference',
  initialState: 'current' satisfies State as State,
  reducers: {
    setPreference(_, action: PayloadAction<State>) {
      return action.payload
    },
  },
})
export const selectCollegeStudentsPreference = (state: { collegeStudentsPreference: State }) =>
  state.collegeStudentsPreference

export const { setPreference } = collegeStudentsPreference.actions

export default collegeStudentsPreference.reducer
